/**
 * 包括契約登録API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 需給契約情報
 */
export interface Sgkb709aReqSupplydemandcontractInfoDto {
    /**
     * 包括契約内需給契約通番号
     */
    inclusioncontractSupplydemandcontractSrno?: string;

    /** 
     * 初回検針予定日
     */
    firstKenshinscheduledate?: string;

    /**
     * 割引・割増開始日
     */
    discountextraStartdate?: string;

    /**
     * 割引・割増解除日
     */
    discountextraUnlockdate?: string;

    /**
     * 割引・割増金額
     */
    discountextraMny?: number;

    /**
     * 割引・割増率
     */
    discountextraRate?: number;

    /**
     * 契約お客さま番号
     */
    firstSrvctrNo?: string;

    /**
     * 使用お客さま番号
     */
    logicDeviceNo?: string;

    /**
     * 内部お客さま番号
     */
    visitNo?: string;

    /**
     * 請求お客さま番号
     */
    recptFixNo?: string;
}
